import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=57c01dee&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=57c01dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c01dee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c01dee')) {
      api.createRecord('57c01dee', component.options)
    } else {
      api.reload('57c01dee', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=57c01dee&scoped=true&", function () {
      api.rerender('57c01dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21g3Gvq3imkY8/JS/comp/GuestBox.vue"
export default component.exports